/**
 * Ruler Overlay Component
 * Displays horizontal and vertical rulers with corner label
 */

import { HorizontalRuler, VerticalRuler } from './ruler';

interface RulerOverlayProps {
  scrollPosition: { x: number; y: number };
  rulerSize: number;
  rulerOffset: number;
  pageWidth: number;
  pageHeight: number;
}

export function RulerOverlay({
  scrollPosition,
  rulerSize,
  rulerOffset,
  pageWidth,
  pageHeight,
}: RulerOverlayProps) {
  return (
    <>
      {/* Corner box with "cm" label */}
      <div 
        className="absolute bg-card border-r border-b border-border flex items-center justify-center text-muted-foreground z-20"
        style={{ 
          width: rulerSize, 
          height: rulerSize, 
          fontSize: '9px',
          top: rulerOffset,
          left: rulerOffset
        }}
      >
        cm
      </div>
      
      {/* Horizontal ruler - moves with horizontal scroll */}
      <div 
        className="absolute z-10 overflow-hidden" 
        style={{ 
          left: rulerOffset + rulerSize, 
          top: rulerOffset,
          width: `calc(100% - ${rulerOffset + rulerSize}px)`,
        }}
      >
        <div style={{ marginLeft: -scrollPosition.x }}>
          <HorizontalRuler widthPx={pageWidth} />
        </div>
      </div>
      
      {/* Vertical ruler - moves with vertical scroll */}
      <div 
        className="absolute z-10 overflow-hidden" 
        style={{ 
          top: rulerOffset + rulerSize, 
          left: rulerOffset,
          height: `calc(100% - ${rulerOffset + rulerSize}px)`,
        }}
      >
        <div style={{ marginTop: -scrollPosition.y }}>
          <VerticalRuler heightPx={pageHeight} />
        </div>
      </div>
    </>
  );
}
